import apiService from 'src/enviroment';

const administratorService = {
  getPermisos: () => apiService.get('/admin/permisos/'),
  getPermiso: (id) => apiService.get(`/admin/permisosusuario/?usuario_id=${id}`),
  postPermiso: (body) => apiService.post('/admin/permisosusuario/', body),
  deletePermisos: (useriD, permisoId) => apiService.delete(
    `/admin/permisosusuario/?usuario_id=${useriD}&permiso_id=${permisoId}`,
  ),
  getUsersBlocked: () => apiService.get('/admin/usuarios/bloqueados/'),
  getUsers: () => apiService.get('/admin/usuarios/'),
  getUser: (body) => apiService.get(`/admin/usuarios/?usuario_id=${body}`),
  unlockUser: (body) => apiService.post(`/admin/usuarios/bloqueados/`, body),
  postUser: (body) => apiService.post('/admin/usuarios/', body),
  putUser: (body) => apiService.put('/admin/usuarios/', body),
  putPassUser: (body) => apiService.put('/admin/usuarios/', body),
  deleteUser: (body) => apiService.delete(`/admin/usuarios/?id=${body}`),
  deleteUnit: (body) => apiService.delete(`/admin/unidadesusuario/?id=${body}`),
  updateUnit: (body) => apiService.post('/admin/unidadesusuario/', body),
};

export default administratorService;
